(function() {
  var config = window.mjsNajoGwp || {};
  if (!config.enabled || !window.fetch) return;

  var thresholdCents = Number(config.thresholdCents || 0);
  var giftProductHandle = config.giftProductHandle || '';
  var promoPropertyKey = config.promoPropertyKey || '_mjs_najo_gwp';
  var promoPropertyValue = config.promoPropertyValue || 'najo-signature-travel-pouch';
  var giftVariantId = Number(config.giftVariantId || 0);
  var syncPromise = null;
  var rerunRequested = false;
  var lastCartSignature = '';
  var baseFetch = window.fetch.bind(window);
  var cartMutationPattern = /\/cart\/(add|change|update)(\.js)?(?:\?|$)/i;

  function getRequestUrl(input) {
    if (typeof input === 'string') return input;
    if (input && typeof input.url === 'string') return input.url;
    return '';
  }

  function getHeaderValue(headers, name) {
    if (!headers) return '';

    if (typeof headers.get === 'function') {
      return headers.get(name) || headers.get(name.toLowerCase()) || '';
    }

    var lowerName = String(name).toLowerCase();
    for (var key in headers) {
      if (Object.prototype.hasOwnProperty.call(headers, key) && String(key).toLowerCase() === lowerName) {
        return headers[key];
      }
    }

    return '';
  }

  function isInternalSyncRequest(input, init) {
    var headers = (init && init.headers) || (input && input.headers) || null;
    return String(getHeaderValue(headers, 'X-MJS-GWP-Sync') || '') === '1';
  }

  function isCartMutationRequest(input) {
    return cartMutationPattern.test(getRequestUrl(input));
  }

  function buildCartSignature(cart) {
    if (!cart || !cart.items) return '';

    return cart.items
      .map(function(item) {
        return String(item.key || item.variant_id || item.id) + ':' + String(item.quantity || 0);
      })
      .sort()
      .join('|');
  }

  function isGiftItem(item) {
    if (!item) return false;

    var itemVariantId = Number(item.variant_id || item.id || 0);
    if (giftVariantId && itemVariantId === giftVariantId) return true;

    if (item.properties && item.properties[promoPropertyKey]) {
      return String(item.properties[promoPropertyKey]).toLowerCase() === String(promoPropertyValue).toLowerCase();
    }

    return false;
  }

  function isNajoItem(item) {
    if (!item || isGiftItem(item)) return false;

    var handle = String(item.handle || '').toLowerCase();
    var title = String(item.product_title || item.title || '').toLowerCase();

    return handle.indexOf('najo') !== -1 || title.indexOf('najo ') === 0;
  }

  function getLineTotal(item) {
    if (!item) return 0;
    if (typeof item.final_line_price === 'number') return item.final_line_price;
    if (typeof item.line_price === 'number') return item.line_price;
    return 0;
  }

  function getQualifyingSubtotal(cart) {
    if (!cart || !cart.items) return 0;

    return cart.items.reduce(function(total, item) {
      return total + (isNajoItem(item) ? getLineTotal(item) : 0);
    }, 0);
  }

  function needsGiftNormalization(giftItems) {
    if (!giftItems.length) return false;
    if (giftItems.length > 1) return true;
    return Number(giftItems[0].quantity || 0) !== 1;
  }

  function queueSync(reason) {
    window.setTimeout(function() {
      syncCart(reason);
    }, 0);
  }

  function requestJson(url, options) {
    options = options || {};

    return new Promise(function(resolve, reject) {
      var xhr = new XMLHttpRequest();
      xhr.open(options.method || 'GET', url, true);
      xhr.withCredentials = true;
      xhr.responseType = 'text';
      xhr.setRequestHeader('Accept', 'application/json');

      if (options.headers) {
        Object.keys(options.headers).forEach(function(headerName) {
          xhr.setRequestHeader(headerName, options.headers[headerName]);
        });
      }

      xhr.onload = function() {
        var responseText = xhr.responseText || '';
        if (xhr.status >= 200 && xhr.status < 300) {
          try {
            resolve(responseText ? JSON.parse(responseText) : {});
          } catch (error) {
            reject(error);
          }
          return;
        }

        reject(new Error('Request failed with status ' + xhr.status + ' for ' + url));
      };

      xhr.onerror = function() {
        reject(new Error('Network error while requesting ' + url));
      };

      xhr.send(options.body || null);
    });
  }

  function fetchCart() {
    return requestJson('/cart.js', {
      method: 'GET',
      headers: {
        'X-MJS-GWP-Sync': '1'
      }
    });
  }

  function updateCart(body) {
    return requestJson('/cart/update.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-MJS-GWP-Sync': '1'
      },
      body: JSON.stringify(body)
    });
  }

  function addGift() {
    return requestJson('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-MJS-GWP-Sync': '1'
      },
      body: JSON.stringify({
      items: [
        {
          id: giftVariantId,
          quantity: 1,
          properties: {
            _mjs_najo_gwp: promoPropertyValue
          }
        }
      ]
      })
    });
  }

  function publishCartUpdate(cart) {
    if (typeof publish === 'function' && window.PUB_SUB_EVENTS && PUB_SUB_EVENTS.cartUpdate) {
      return Promise.resolve(
        publish(PUB_SUB_EVENTS.cartUpdate, {
          source: 'mjs-najo-gwp',
          cartData: cart,
          variantId: giftVariantId
        })
      );
    }

    document.dispatchEvent(
      new CustomEvent('mjs:najo-gwp-sync', {
        detail: { cart: cart }
      })
    );

    return Promise.resolve();
  }

  function resolveGiftVariantId() {
    if (giftVariantId) return Promise.resolve(giftVariantId);
    if (!giftProductHandle) return Promise.resolve(0);

    return requestJson('/products/' + encodeURIComponent(giftProductHandle) + '.js', {
      method: 'GET',
      headers: {
        'X-MJS-GWP-Sync': '1'
      }
    })
      .then(function(product) {
        if (!product || !product.variants || !product.variants.length) return 0;
        giftVariantId = Number(product.variants[0].id || 0);
        window.mjsNajoGwp.giftVariantId = giftVariantId;
        return giftVariantId;
      })
      .catch(function(error) {
        console.warn('MJS NAJO GWP: unable to resolve gift variant.', error);
        return 0;
      });
  }

  function syncCart(reason) {
    if (syncPromise) {
      rerunRequested = true;
      return syncPromise;
    }

    syncPromise = resolveGiftVariantId()
      .then(function(resolvedVariantId) {
        if (!resolvedVariantId || !thresholdCents) return null;

        return fetchCart().then(function(cart) {
          var cartSignature = buildCartSignature(cart);
          if (cartSignature === lastCartSignature && reason !== 'force') return cart;

          var qualifyingSubtotal = getQualifyingSubtotal(cart);
          var giftItems = (cart.items || []).filter(isGiftItem);
          var qualifies = qualifyingSubtotal >= thresholdCents;
          var mutationPromise = null;

          if (qualifies && !giftItems.length) {
            mutationPromise = addGift();
          } else if (qualifies && needsGiftNormalization(giftItems)) {
            var normalizeUpdates = {};
            giftItems.forEach(function(item, index) {
              normalizeUpdates[item.key] = index === 0 ? 1 : 0;
            });
            mutationPromise = updateCart({ updates: normalizeUpdates });
          } else if (!qualifies && giftItems.length) {
            var removeUpdates = {};
            giftItems.forEach(function(item) {
              removeUpdates[item.key] = 0;
            });
            mutationPromise = updateCart({ updates: removeUpdates });
          }

          if (!mutationPromise) {
            lastCartSignature = cartSignature;
            return cart;
          }

          return mutationPromise
            .then(fetchCart)
            .then(function(updatedCart) {
              lastCartSignature = buildCartSignature(updatedCart);
              return publishCartUpdate(updatedCart).then(function() {
                return updatedCart;
              });
            });
        });
      })
      .catch(function(error) {
        console.error('MJS NAJO GWP sync failed.', error);
        return null;
      })
      .finally(function() {
        syncPromise = null;
        if (rerunRequested) {
          rerunRequested = false;
          queueSync('rerun');
        }
      });

    return syncPromise;
  }

  window.fetch = function(input, init) {
    var request = baseFetch(input, init);

    if (isCartMutationRequest(input) && !isInternalSyncRequest(input, init)) {
      request
        .then(function(response) {
          if (response && response.ok) queueSync('cart-mutation');
        })
        .catch(function() {});
    }

    return request;
  };

  document.addEventListener('cart:updated', function() {
    queueSync('cart-updated-event');
  });

  document.addEventListener('DOMContentLoaded', function() {
    if (typeof subscribe === 'function' && window.PUB_SUB_EVENTS && PUB_SUB_EVENTS.cartUpdate) {
      subscribe(PUB_SUB_EVENTS.cartUpdate, function(event) {
        if (event && event.source === 'mjs-najo-gwp') return;
        queueSync('pubsub-cart-update');
      });
    }

    queueSync('initial');
  });

  window.mjsNajoGwp.sync = function() {
    return syncCart('manual');
  };
})();
